import React from "react";
import "./CustomerCard.css";

const CustomerCard = ({ customer, onCardClick }) => {
  return (
    <div className='customercard' onClick={(e) => onCardClick(customer)}>
      <div className='ccardheader'>
        <h2>{customer.companyCode}</h2>
        {/* <p style={{ textAlign: "right" }}>{user.active === "y" ? "Active" : "Disabled"}</p> */}
      </div>
      <div className='ccardbody'>
        <li>
          <p>Company Name:</p>
          <p>{customer.companyName}</p>
        </li>
        <li>
          <p>Address:</p>
          <p>{customer.streetAddress}</p>
        </li>
        <li>
          <p>City:</p>
          <p>{customer.city}</p>
        </li>
        <li>
          <p>Country:</p>
          <p>{customer.country}</p>
        </li>
        <li>
          <p>Region:</p>
          <p>{customer.region}</p>
        </li>
      </div>
    </div>
  );
};

export default CustomerCard;
